export const HTTP_STATUS_MESSAGES = {
  400: "Invalid parameters provided",
  401: "Authentication required",
  403: "Access denied",
  404: "Resource not found",
  409: "Resource already exists",
  422: "Validation failed",
  429: "Too many requests. Please try again later.",
  500: "Something went wrong, please try again later",
  502: "Something went wrong, please try again later",
  503: "Service unavailable. Please try again later",
  504: "Server took too long to respond, please try again later",
};

export const NETWORK_ERROR_MESSAGE =
  "Network error — please check your connection";
